export const ROUTES = {
  largeHome: '/large-home',
  local: '/local',
  longDistance: '/long-distance',
  outOfServiceArea: '/out-of-service-area',
};

export const TITLES = {
  [ROUTES.largeHome]: () => html =>
    html`
      3+ Bedroom Moves
    `,
  [ROUTES.local]: ({ currentMove: { movingCompany } }) => html =>
    movingCompany
      ? html`
          Reserve with ${movingCompany.name}
        `
      : html`
          Reserve Your Moving Company
        `,
  [ROUTES.longDistance]: ({ currentMove: { movingCompany } }) => html =>
    movingCompany
      ? html`
          Long Distance Moves
        `
      : html`
          Reserve Your Moving Company
        `,
  [ROUTES.outOfServiceArea]: () => html =>
    html`
      Out of Service Area
    `,
};

export const DESCRIPTIONS = {
  [ROUTES.largeHome]: () => html => html`
    <span class="condensed"
      >For 3 bedrooms or more you'll need to schedule an in-home estimate in
      order to get an accurate price. Contact us to arrange a convenient
      time.</span
    >
  `,

  [ROUTES.local]: ({ currentMove: { movingCompany } }) => html =>
    // prettier-ignore
    movingCompany
      ? html`Just answer a few questions and get real-time quotes from ${movingCompany.name}.`
      : html`
  Let's find you a trustworthy moving company. Just answer a few questions and we'll provide real-time quotes from Updater Certified Moving Companies who meet your exact needs.`,

  [ROUTES.longDistance]: ({ currentMove: { movingCompany } }) => html =>
    movingCompany
      ? html`
          <span class="condensed"
            >For non-local moves you\'ll need to schedule an in-home estimate in
            order to get an accurate price. Contact us to arrange a convenient
            time.</span
          >
        `
      : html`
          For long distance moves like yours, the first step in getting an
          accurate quote is to schedule an in-home estimate with a moving
          company. Below are the highest-rated companies available for your
          move.
        `,

  [ROUTES.outOfServiceArea]: ({
    currentMove: { movingCompany },
    moveIqMove: {
      fromAddressDetails: {
        address: { postalCode: fromZip },
      },
      toAddressDetails: {
        address: { postalCode: toZip },
      },
    },
  }) => html => {
    const reason = movingCompany
      ? `We don’t provide service from ${fromZip} to ${toZip}.`
      : `There are no moving companies in our system that provide service from ${fromZip} to ${toZip}.`;

    html`
      <span class="condensed">
        Oh no! ${reason} If you have flexibility in your move, you can try
        another address.
      </span>
    `;
  },
};
